import { render, staticRenderFns } from "./edit-violation-modal.vue?vue&type=template&id=8cabb122&scoped=true&"
import script from "./edit-violation-modal.vue?vue&type=script&lang=js&"
export * from "./edit-violation-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-violation-modal.vue?vue&type=style&index=0&id=8cabb122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cabb122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cabb122')) {
      api.createRecord('8cabb122', component.options)
    } else {
      api.reload('8cabb122', component.options)
    }
    module.hot.accept("./edit-violation-modal.vue?vue&type=template&id=8cabb122&scoped=true&", function () {
      api.rerender('8cabb122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/violations/edit-violation-modal.vue"
export default component.exports